import { NgModule } from '@angular/core';
import { AngularEditorComponent } from './angular-editor.component';
import { AngularEditorToolbarComponent } from './angular-editor-toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AeSelectComponent } from './ae-select/ae-select.component';
import { AeButtonComponent } from "./ae-button/ae-button.component";
import { AeToolbarSetComponent } from './ae-toolbar-set/ae-toolbar-set.component';
// import { SharedModule } from '../../../../shared.module';
import { VideoInsertDialogComponent } from './video-insert-dialog/video-insert-dialog.component';
import { ImageInsertDialogComponent } from './image-insert-dialog/image-insert-dialog.component';
import { AngularEditorService } from './angular-editor.service';
import { UrlInsertDialogComponent } from './url-insert-dialog/url-insert-dialog.component';
import { EditorLoadingScreenComponent } from './editor-loading-screen/editor-loading-screen.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatTooltipModule, MatProgressSpinnerModule, MatProgressBarModule,
    MatSnackBarModule, MatSelectModule,
  ],
  declarations: [AngularEditorComponent, AngularEditorToolbarComponent, AeSelectComponent, AeButtonComponent, AeToolbarSetComponent, VideoInsertDialogComponent, ImageInsertDialogComponent, UrlInsertDialogComponent, EditorLoadingScreenComponent],
  exports: [AngularEditorComponent,
    AngularEditorToolbarComponent,
    AeSelectComponent,
    AeButtonComponent,
    AeToolbarSetComponent,],
  providers: [AngularEditorService]
})
export class AngularEditorModule {
}
